import Explainer from '../blocks';

import styles from './TrueQuality.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

const TrueQuality = () => {
  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
      once
    >
      <g transform="translate(89 115)">
        <g filter="url(#filter0_d_3640_7594)" className={styles.one}>
          <g clipPath="url(#clip0_3640_7594)">
            <rect
              x="30"
              y="10.2148"
              width="424"
              height="65"
              rx="6"
              fill="white"
            />
            <mask id="path-2-inside-1_3640_7594" fill="white">
              <path d="M30 16.2148C30 12.9011 32.6863 10.2148 36 10.2148H448C451.314 10.2148 454 12.9011 454 16.2148V69.2148C454 72.5286 451.314 75.2148 448 75.2148H36C32.6863 75.2148 30 72.5286 30 69.2148V16.2148Z" />
            </mask>
            <path
              d="M30 16.2148C30 12.9011 32.6863 10.2148 36 10.2148H448C451.314 10.2148 454 12.9011 454 16.2148V69.2148C454 72.5286 451.314 75.2148 448 75.2148H36C32.6863 75.2148 30 72.5286 30 69.2148V16.2148Z"
              fill="#F9FCFF"
            />
            <path
              d="M30 10.2148H454H30ZM454 69.2148C454 73.0808 450.866 76.2148 447 76.2148H37C33.134 76.2148 30 73.0808 30 69.2148C30 71.9763 32.6863 74.2148 36 74.2148H448C451.314 74.2148 454 71.9763 454 69.2148ZM30 75.2148V10.2148V75.2148ZM454 10.2148V75.2148V10.2148Z"
              fill="#E1EAF3"
              mask="url(#path-2-inside-1_3640_7594)"
            />
            <path
              d="M53.8124 23.7167C53.3444 23.6972 52.8149 23.8247 52.5704 24.4022C52.3334 24.9632 52.1459 26.1842 52.0604 27.8162L53.8949 28.7027C53.8649 27.5972 53.9054 26.5577 54.0089 25.6037C53.9699 26.0522 53.9249 27.0437 54.0179 28.6622C54.0464 29.1751 54.0914 29.7496 54.1499 30.3871C54.1529 30.4231 54.1529 30.4576 54.1604 30.4906C54.2827 31.7005 54.4372 32.907 54.6239 34.1086C54.7094 34.6606 54.8129 35.2366 54.9164 35.8486L54.9014 35.8636C54.9224 35.8786 54.9239 35.8906 54.9224 35.8981L54.9674 36.1381C55.0124 36.3811 55.0574 36.6301 55.1069 36.8791L55.2689 37.7085L55.3529 38.142C55.5637 39.1798 55.7922 40.2141 56.0384 41.244C56.1734 41.817 56.3174 42.414 56.4689 43.023C56.6159 43.602 56.7674 44.1975 56.9324 44.8125C57.0764 45.3555 57.2309 45.915 57.3869 46.488C57.3914 46.515 57.4049 46.542 57.4094 46.5705C57.5769 47.1637 57.7469 47.7562 57.9194 48.348L57.9929 48.609C58.1099 49.0005 58.2299 49.4085 58.3559 49.8165C58.2069 49.7545 58.0602 49.687 57.9164 49.614L57.6314 48.633C57.6014 48.5175 57.5684 48.411 57.5384 48.2955L57.5354 48.2895L57.5294 48.2865C57.3989 47.8365 57.2744 47.376 57.1439 46.9125C57.1094 46.782 57.0779 46.653 57.0404 46.518L56.5694 44.751C56.4194 44.1795 56.2784 43.6035 56.1344 43.02C55.9934 42.435 55.8569 41.85 55.7189 41.262C55.5794 40.6605 55.4474 40.062 55.3214 39.4575C55.1939 38.8635 55.0799 38.2605 54.9614 37.668C54.849 37.0843 54.7435 36.4993 54.6449 35.9131C54.6389 35.8936 54.6359 35.8681 54.6299 35.8516L54.6359 35.8486C54.5504 35.2696 54.4619 34.6936 54.3749 34.1236C54.2919 33.5224 54.2149 32.9204 54.1439 32.3176C54.0049 31.117 53.9188 29.9108 53.8859 28.7027L52.056 27.8177C52.05 27.9287 52.0409 28.0427 52.0364 28.1627C52.0184 28.6037 52.0064 29.0701 52.0019 29.5576C51.9976 30.1361 52.0006 30.7147 52.0109 31.2931C52.0244 31.8481 52.0484 32.4256 52.0784 33.0151C52.1084 33.5191 52.1415 34.0276 52.1835 34.5481L52.1864 34.6066L52.1954 34.6126C52.1999 34.6471 52.2059 34.6876 52.2044 34.7266C52.2539 35.2786 52.3004 35.8351 52.3649 36.3991C52.4833 37.4661 52.6349 38.529 52.8194 39.5865C52.8344 39.6825 52.8554 39.783 52.8719 39.879C53.0862 41.0521 53.3601 42.2137 53.6924 43.359C53.7974 43.7145 53.9024 44.055 54.0074 44.379C54.1019 44.652 54.2024 44.9265 54.2984 45.1965C54.5309 45.8295 54.7889 46.4445 55.0664 47.0445L55.0754 47.0505C55.0833 47.0763 55.0933 47.1013 55.1054 47.1255C55.4429 47.853 55.8179 48.5505 56.2379 49.218C56.2529 49.2375 56.2679 49.2675 56.2829 49.2885C55.6004 49.014 54.3944 49.1415 54.4034 49.143C55.6484 49.575 56.7389 50.103 57.4274 50.9055C57.1529 51.2055 56.6429 51.4335 55.9979 51.621C56.8889 51.717 57.3839 51.5625 57.5654 51.483C57.1004 51.873 56.8409 52.5808 56.6129 53.3428C57.1379 52.4878 57.6569 51.9195 58.1624 51.702C58.2794 52.089 58.4054 52.4878 58.5284 52.8838C57.3774 55.1416 56.2652 57.4189 55.1924 59.7148C55.3303 59.6964 55.4614 59.6439 55.5739 59.5621C55.6865 59.4805 55.7771 59.3721 55.8374 59.2468C56.0324 58.8238 57.0824 56.5843 58.6994 53.4343C59.3189 55.3888 60.0194 57.4528 60.7784 59.5978C60.854 59.5003 60.904 59.3854 60.9239 59.2635C60.9438 59.1417 60.933 59.0169 60.8924 58.9003C60.1989 56.9412 59.5448 54.9682 58.9304 52.9828C59.1614 52.5343 59.4044 52.065 59.6564 51.585C59.8439 51.645 60.0389 51.726 60.2399 51.8175C60.5444 52.0965 60.7679 52.5538 60.9629 53.0773C61.0183 52.4839 60.8384 51.8925 60.4619 51.4305C62.4643 51.8175 64.2823 51.5655 65.3923 50.2155C65.4936 50.0904 65.5896 49.9612 65.6803 49.8285C65.1928 50.2845 64.6573 50.4345 63.7108 50.238C65.2048 49.8165 65.9953 49.3125 66.7633 48.408C66.9433 48.1905 67.1293 47.9535 67.3198 47.688C65.9053 48.771 64.4293 48.921 62.9698 48.4275L62.9023 48.4005C64.2733 48.4305 66.2068 47.6895 67.5403 46.617C68.1553 46.122 68.7343 45.522 69.2953 44.802C69.7153 44.2635 70.1203 43.662 70.5253 42.978C70.8763 42.3885 71.2273 41.742 71.5753 41.0385C71.2161 41.1561 70.8427 41.2252 70.4653 41.244L70.2493 41.256C70.1773 41.259 70.1098 41.256 70.0303 41.259C71.3578 40.962 72.2803 40.149 73.0213 39.0885C72.6613 39.264 72.0793 39.4815 71.4163 39.534C71.3293 39.543 71.2363 39.543 71.1433 39.543C71.1238 39.54 71.1013 39.543 71.0728 39.54C71.5318 39.423 71.9338 39.273 72.2878 39.0765C72.4741 38.9701 72.6535 38.8518 72.8248 38.7225C72.8908 38.667 72.9568 38.6175 73.0198 38.5635C73.1683 38.4345 73.3093 38.2935 73.4398 38.133C73.4818 38.082 73.5238 38.0385 73.5598 37.986C73.6138 37.911 73.6693 37.839 73.7158 37.767C73.9945 37.3681 74.25 36.9535 74.4808 36.5251C74.5033 36.4786 74.5288 36.4396 74.5498 36.3931C74.6098 36.2671 74.6698 36.1531 74.7148 36.0526C74.7778 35.9041 74.8258 35.7841 74.8528 35.6956C74.802 35.7273 74.7475 35.753 74.6908 35.7721C74.2813 35.9401 73.6003 36.0526 73.0618 36.0736C73.0558 36.0736 73.0498 36.0736 73.0423 36.0796H72.9418C74.0218 35.7586 74.5423 35.4046 75.0747 34.8526C75.6984 34.1776 76.2766 33.462 76.8057 32.7106C77.2017 32.1556 77.5632 31.6036 77.8437 31.1026C78.0078 30.8144 78.1569 30.518 78.2907 30.2146C78.3897 29.9791 78.4737 29.7571 78.5487 29.5396C77.8497 29.5546 77.0697 29.5561 76.3287 29.5396C77.0712 29.5546 77.8512 29.5501 78.5547 29.5321C79.3047 27.3047 78.6492 26.1392 78.6492 26.1392C78.6492 26.1392 77.8602 24.3212 76.5492 24.8627C75.9102 25.1252 74.7913 25.9577 73.4248 27.2027L74.1958 29.3776C74.9929 28.5208 75.8463 27.718 76.7502 26.9747C76.3647 27.3047 75.5397 28.0637 74.3278 29.4406C73.9438 29.8756 73.5223 30.3766 73.0618 30.9361C73.0363 30.9661 73.0093 30.9931 72.9913 31.0261C72.1291 32.0972 71.2959 33.191 70.4923 34.3066C70.1203 34.8166 69.7453 35.3626 69.3448 35.9386H69.3208C69.3238 35.9686 69.3148 35.9806 69.3058 35.9866L69.1543 36.2146C68.9983 36.4471 68.8348 36.6796 68.6773 36.9196L68.1493 37.7205C68.0578 37.8555 67.9633 37.992 67.8703 38.136C67.5943 38.559 67.3198 38.9955 67.0333 39.4455C66.303 40.6044 65.5888 41.7735 64.8913 42.9525C64.2046 44.1145 63.534 45.2862 62.8798 46.467C62.8618 46.4925 62.8498 46.527 62.8288 46.5525C62.4927 47.1628 62.1588 47.7742 61.8268 48.387L61.6813 48.6585C61.4263 49.1355 61.1623 49.6215 60.9014 50.127C60.9014 50.133 60.8939 50.139 60.8924 50.1465C60.8534 50.2185 60.8174 50.286 60.7844 50.358C60.6089 50.691 60.4574 50.994 60.1094 51.663C60.0032 51.5595 59.886 51.4678 59.7599 51.39L60.2774 50.415C60.3479 50.2815 60.4214 50.1495 60.4919 50.01L60.5519 49.8945L61.3708 48.393L61.5658 48.0435V48.0345L61.5643 48.0255C61.8178 47.5605 62.0818 47.0955 62.3443 46.6155C62.4208 46.485 62.4973 46.356 62.5738 46.218C62.9098 45.6255 63.2548 45.027 63.5998 44.4225C64.6281 42.6468 65.6958 40.8945 66.8023 39.1665C67.1728 38.5875 67.5568 38.0115 67.9333 37.4385C68.0713 37.2315 68.2063 37.0306 68.3518 36.8236C68.5897 36.4717 68.8297 36.1212 69.0718 35.7721C69.0823 35.7541 69.1003 35.7361 69.1108 35.7166H69.1198C69.5098 35.1826 69.8953 34.6471 70.2793 34.1191C70.6963 33.5596 71.1103 33.0166 71.5243 32.4841C72.3667 31.4081 73.2561 30.3696 74.1898 29.3716L73.4173 27.2027C73.3273 27.2882 73.2283 27.3767 73.1293 27.4697C72.7444 27.828 72.3654 28.1925 71.9923 28.5632C71.5498 29.0041 71.0968 29.4721 70.6243 29.9656C69.7839 30.8627 68.9676 31.782 68.1763 32.7226L68.1313 32.7721L68.1343 32.7841C68.1088 32.8141 68.0848 32.8501 68.0533 32.8801C67.6543 33.3646 67.2463 33.8536 66.8518 34.3576C66.0993 35.3099 65.3764 36.2854 64.6843 37.2825C64.6198 37.3725 64.5568 37.4715 64.4938 37.5615C63.7341 38.6766 63.0316 39.8295 62.3893 41.016C62.1943 41.3865 62.0053 41.7435 61.8343 42.0885C61.6903 42.381 61.5538 42.681 61.4173 42.975C61.1023 43.6695 60.8204 44.37 60.5684 45.0735L60.5714 45.0825C60.5558 45.1102 60.5428 45.1393 60.5324 45.1695C60.3704 45.624 60.2279 46.0815 60.0974 46.5405C59.8874 46.8015 59.6444 47.028 59.3729 47.2305C59.3096 47.152 59.2441 47.0755 59.1764 47.001C59.8396 46.006 60.2627 44.8708 60.4124 43.6845C60.4912 42.9421 60.4831 42.193 60.3884 41.4525C60.3194 40.8525 60.1994 40.2225 60.0314 39.5415C59.8859 38.952 59.7059 38.3265 59.4869 37.6695C59.3504 37.947 59.1569 38.22 58.9184 38.487L58.7894 38.628C58.7459 38.676 58.6994 38.718 58.6514 38.769C59.3024 37.758 59.3804 36.6736 59.1884 35.5471C59.0226 36.0131 58.7736 36.4451 58.4534 36.8221C58.4039 36.8791 58.3454 36.9376 58.2884 36.9961C58.2734 37.0066 58.2599 37.0231 58.2389 37.0381C58.4549 36.6781 58.6139 36.3376 58.7159 35.9911C58.7402 35.9193 58.7602 35.8462 58.7759 35.7721C58.7994 35.6604 58.8184 35.5478 58.8329 35.4346L58.8599 35.2156C58.8738 35.0388 58.8728 34.8612 58.8569 34.6846C58.8524 34.6246 58.8509 34.5706 58.8419 34.5151C58.8269 34.4326 58.8179 34.3576 58.8014 34.2841C58.7294 33.8588 58.6327 33.4381 58.5119 33.0241C58.4969 32.9821 58.4894 32.9401 58.4729 32.8981C58.4324 32.7796 58.4009 32.6746 58.3649 32.5846C58.3256 32.4778 58.2805 32.3731 58.2299 32.2711C58.2183 32.323 58.2007 32.3733 58.1774 32.4211C58.0244 32.7811 57.6674 33.2761 57.3419 33.6211C57.3374 33.6256 57.3314 33.6286 57.3314 33.6361L57.2714 33.7006C57.7484 32.8306 57.8564 32.2816 57.8489 31.6036C57.8224 30.7917 57.7423 29.9825 57.6089 29.1811C57.5222 28.6234 57.406 28.0706 57.2609 27.5252C57.1849 27.2418 57.0948 26.9625 56.9909 26.6882C56.9115 26.4898 56.8255 26.2942 56.7329 26.1017L56.7359 26.0957C55.8209 24.2267 54.6869 23.9012 54.6869 23.9012C54.6869 23.9012 54.2804 23.7362 53.8124 23.7167ZM58.8824 47.391L58.9304 47.514V47.517C58.8404 47.5665 58.7564 47.6175 58.6634 47.6625C58.6454 47.6685 58.6274 47.6805 58.6049 47.6895C58.7035 47.5948 58.7966 47.4946 58.8839 47.3895L58.8824 47.391ZM57.9779 49.83C58.1729 50.034 58.3529 50.193 58.5089 50.31L58.6139 50.6505C58.4892 50.6686 58.366 50.6952 58.2449 50.73L58.1999 50.583C58.1639 50.457 58.1279 50.328 58.0859 50.1975L58.0544 50.088L57.9779 49.83ZM58.3679 51.1425C58.5036 51.1395 58.6393 51.1446 58.7744 51.1575L58.8794 51.501C59.0018 51.4792 59.1268 51.4771 59.2499 51.495L58.7609 52.4353C58.6284 52.0048 58.4974 51.5739 58.3679 51.1425Z"
              fill="#768FA2"
            />
            <text
              fill="#0A2F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="93" y="38.8548">
                super-useful-api
              </tspan>
            </text>
            <text
              fill="#5F7886"
              fontFamily="var(--font-family-mono)"
              fontSize="13"
              letterSpacing="0.65px"
            >
              <tspan x="93" y="58.2648">
                @0.0.4
              </tspan>
            </text>
          </g>
        </g>
        <g filter="url(#filter1_d_3640_7594)" className={styles.two}>
          <g clipPath="url(#clip1_3640_7594)">
            <rect
              x="30"
              y="87.2148"
              width="424"
              height="130"
              rx="6"
              fill="white"
            />
            <rect x="29.5" y="86.7148" width="213" height="65" fill="#FFE3E8" />
            <rect
              x="29.5"
              y="86.7148"
              width="213"
              height="65"
              stroke="#FCC0CB"
              fill="var(--brand-color-red-2)"
            />
            <text
              fill="#B73B55"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="46" y="110.415">
                Last updated
              </tspan>
            </text>
            <text
              fill="#B73B55"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="46" y="135.855">
                14 months
              </tspan>
            </text>
            <rect
              x="241.5"
              y="86.7148"
              width="213"
              height="65"
              fill="#FFE3E8"
            />
            <rect
              x="241.5"
              y="86.7148"
              width="213"
              height="65"
              stroke="#FCC0CB"
              fill="var(--brand-color-red-2)"
            />
            <text
              fill="#B73B55"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="258" y="110.415">
                Maintainers
              </tspan>
            </text>
            <text
              fill="#B73B55"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="258" y="135.855">
                1
              </tspan>
            </text>
            <mask
              id="path-14-outside-2_3640_7594"
              maskUnits="userSpaceOnUse"
              x="29"
              y="152.215"
              width="214"
              height="65"
              fill="black"
            >
              <rect fill="white" x="29" y="152.215" width="214" height="65" />
              <path d="M30 152.215H242V216.215H30V152.215Z" />
            </mask>
            <path d="M30 152.215H242V216.215H30V152.215Z" fill="white" />
            <path
              d="M242 216.215V217.215H243V216.215H242ZM30 216.215H29V217.215H30V216.215ZM241 152.215V216.215H243V152.215H241ZM242 215.215H30V217.215H242V215.215ZM31 216.215V152.215H29V216.215H31Z"
              fill="#E1EAF3"
              mask="url(#path-14-outside-2_3640_7594)"
            />
            <text
              fill="#5B798A"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="46" y="175.415">
                OpenSSF Scorecard
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="46" y="200.855">
                3.6
              </tspan>
            </text>
            <mask
              id="path-18-outside-3_3640_7594"
              maskUnits="userSpaceOnUse"
              x="241"
              y="152.215"
              width="214"
              height="65"
              fill="black"
            >
              <rect fill="white" x="241" y="152.215" width="214" height="65" />
              <path d="M242 152.215H454V216.215H242V152.215Z" />
            </mask>
            <path d="M242 152.215H454V216.215H242V152.215Z" fill="white" />
            <path
              d="M454 216.215V217.215H455V216.215H454ZM242 216.215H241V217.215H242V216.215ZM453 152.215V216.215H455V152.215H453ZM454 215.215H242V217.215H454V215.215ZM243 216.215V152.215H241V216.215H243Z"
              fill="#E1EAF3"
              mask="url(#path-18-outside-3_3640_7594)"
            />
            <text
              fill="#5B798A"
              fontFamily="var(--font-family-mono)"
              fontSize="12"
              letterSpacing="0em"
            >
              <tspan x="258" y="175.415">
                Critical CVEs
              </tspan>
            </text>
            <text
              fill="#092F45"
              fontFamily="var(--font-family-body)"
              fontSize="16"
              letterSpacing="0.005em"
            >
              <tspan x="258" y="200.855">
                2
              </tspan>
            </text>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3640_7594"
          x="0"
          y="0.214844"
          width="484"
          height="125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.568627 0 0 0 0 0.368627 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3640_7594"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3640_7594"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3640_7594"
          x="0"
          y="77.2148"
          width="484"
          height="190"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.568627 0 0 0 0 0.368627 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3640_7594"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3640_7594"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3640_7594">
          <rect
            x="30"
            y="10.2148"
            width="424"
            height="65"
            rx="6"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_3640_7594">
          <rect
            x="30"
            y="87.2148"
            width="424"
            height="130"
            rx="6"
            fill="white"
          />
        </clipPath>
      </defs>
    </Explainer>
  );
};

export default TrueQuality;
